import "./Header.css"
import Logo from "../../assets/images/company_logo_svg.svg";
import SvgSearch from "../../assets/images/search.svg";
import SvgCart from "../../assets/images/cart.svg";
import SvgPerson from "../../assets/images/person.svg";
import PdtCatList from "../../components/PdtCatList/PdtCatList";
import SignIn from "../../components/SignIn/SignIn";

import { Link, useNavigate } from "react-router-dom";

import { getRootUrl, useData } from "../../consts";

import ShoppingCart, {CartBtn} from "../ShoppingCart/ShoppingCart";
import { useRef } from "react";

const rootUrl = getRootUrl();
// hide menu after click
const handleClickTblList = evt=>{
    const menu = evt.target.closest(".dropdown-menu");
    if(menu && !menu.classList.contains("form-menu")){
        menu.style.top = "1000000px";
        setTimeout(_=>menu.style.top = "auto",100);
        evt.target.blur();
    }
    // evt.target.blur();
}

const theme = 2;
export default function Header(){
    const navigate = useNavigate();
    const {setSearchFilters, loggedIn, userInfo} = useData();
    const refSearch = useRef();

    return <>
        {(theme===1)&&<header>
            <div className="text-white" id="nav">
                <div className="container-fluid px-0" >
                    <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
                        <Link className="navbar-brand" to="#"><img className="mt-2" src={Logo} id="logo" /></Link>

                        <ul className="nav col-12 col-lg-auto my-2 justify-content-center my-md-0 text-small">
                            <li>
                            <a href="#" className="nav-link text-secondary">
                                <svg className="bi d-block mx-auto mb-1" width="24" height="24"></svg>
                                Home
                            </a>
                            </li>
                            <li>
                            <a href="#" className="nav-link">
                                <svg className="bi d-block mx-auto mb-1" width="24" height="24"></svg>
                                Dashboard
                            </a>
                            </li>
                            <li>
                            <a href="#" className="nav-link">
                                <svg className="bi d-block mx-auto mb-1" width="24" height="24"></svg>
                                Orders
                            </a>
                            </li>
                            <li>
                                <a href="#" className="nav-link">
                                    <svg className="bi d-block mx-auto mb-1" width="24" height="24"></svg>
                                    Products
                                </a>
                            </li>
                            <li>
                            <a href="#" className="nav-link">
                                <svg className="bi d-block mx-auto mb-1" width="24" height="24"></svg>
                                Customers
                            </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="px-3 py-2">
            <div className="container d-flex flex-wrap justify-content-center">
                <form className="col-12 col-lg-auto mb-2 mb-lg-0 me-lg-auto">
                <input type="search" className="form-control" placeholder="Search..." aria-label="Search" ></input>
                </form>

                <div className="text-end">
                <button type="button" className="btn btn-light text-dark me-2">Login</button>
                <button type="button" className="btn btn-primary">Sign-up</button>
                </div>
            </div>
            </div>
        </header>}

        {
            (theme===2)&&<header>
                <div className="container-fluid px-0">
                    <div className="row">
                        <nav className="navbar navbar-expand-lg navbar-light">
                        <div className="container-fluid px-0">
                            <a className="navbar-brand" href="#"><img src={Logo} id="logo" /></a>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent"
                                onClick={handleClickTblList}
                            >
                                <ul className="navbar-nav me-auto mb-2 mb-lg-0 col-md-6">
                                    <li className="nav-item">
                                        <Link className="nav-link active" aria-current="page" to={`${rootUrl}/app2`}>Home</Link>
                                    </li>
    
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="true">
                                            Services
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li><a className="dropdown-item" href="#">Product Customizing</a></li>
                                            <li><a className="dropdown-item" href="#">Furniture Installation</a></li>
                                            <li><hr className="dropdown-divider" /></li>
                                            <li><a className="dropdown-item" href="#">Something else here</a></li>
                                        </ul>
                                    </li>
    
                                    <li className="nav-item dropdown"
                                        // onClick={handleClickTblList}
                                    >
                                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="true">
                                            Products
                                        </a>
                                        <PdtCatList />
                                    </li>
    
                                    {/* <li className="nav-item">
                                        <Link className="nav-link" to={`${rootUrl}/app2/aboutUs`}>About Us</Link>
                                    </li> */}

                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="true">
                                            About us
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link className="dropdown-item" aria-current="page" to={`${rootUrl}/app2/aboutUs/profile`}>Willowest Profile</Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" aria-current="page" to={`${rootUrl}/app2/aboutUs/howWeWork`}>How we work</Link>
                                            </li>
                                            <li><a className="dropdown-item" href="#">Our clients</a></li>
                                            <li><a className="dropdown-item" href="#">Press room</a></li>
                                            <li><hr className="dropdown-divider" /></li>
                                            <li><a className="dropdown-item" href="#">Something else here</a></li>
                                        </ul>
                                    </li>

                                </ul>
    
                                {/* <form className="d-flex col-md-3 pe-3"> */}
                                <div className="d-flex col-md-3 pe-3">
                                    <div className="input-group">
                                        <input className="form-control mx-0" type="search" placeholder="Search" aria-label="Search"
                                            ref={refSearch}
                                            onChange={evt=>{
                                                if(!refSearch.current.value){
                                                    setSearchFilters({'name': refSearch.current.value});
                                                    // navigate(`${rootUrl}/app2/search`);
                                                }
                                            }}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-success"
                                            onClick={evt=>{
                                                setSearchFilters({'name': refSearch.current.value});
                                                // refSearch.current.value = "";
                                                navigate(`${rootUrl}/app2/search`);
                                            }}
                                        ><img className="align-middle"
                                            src={SvgSearch} style={{"width":"1.2em"}}

                                        /></button>
                                    </div>
                                </div>
                                {/* </form> */}
    
                                <ul className="navbar-nav  d-flex col-md-3">
                                    <SignIn />
                                    <li className="nav-item d-flex">
                                        <CartBtn />
                                        {/* <img className="pt-3" src={SvgCart} style={{"width":"1.5em"}} /> */}
                                        {/* <a className="nav-link pull-left"  role="button" aria-current="page" href="#"  data-bs-toggle="dropdown" aria-expanded="false">Cart</a> */}
                                    </li>
                                </ul>
    
                            </div>
                        </div>
                        </nav>
                    </div>


                    
                </div>
            </header>
        }

        {
            (theme===3)&&<header>
                <div className="container-fluid px-0">


                    <nav class="navbar navbar-expand-lg navbar-light bg-light d-flex align-items-baseline">
                        <div class="container-fluid justify-content-center">
                            {/* <a class="navbar-brand" href="#">Navbar</a> */}
                            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                            <span class="navbar-toggler-icon"></span>
                            </button>
                            <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
                            <ul class="navbar-nav">

                                <li className="nav-item mx-5">
                                    <Link className="nav-link active" aria-current="page" to={`${rootUrl}/app2`}>Home</Link>
                                </li>

                                <li className="nav-item dropdown mx-5">
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="true">
                                        Services
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li><a className="dropdown-item" href="#">Product Customizing</a></li>
                                        <li><a className="dropdown-item" href="#">Furniture Installation</a></li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li><a className="dropdown-item" href="#">Something else here</a></li>
                                    </ul>
                                </li>

                                <li className="nav-item mx-5">
                                    <Link className="nav-link active" aria-current="page" to={`${rootUrl}/app2`}>
                                        <img src={Logo} id="logo" style={{"width":"10em"}} className="m-0"/>
                                    </Link>
                                </li>

                                <li className="nav-item dropdown mx-5"
                                    // onClick={handleClickTblList}
                                >
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="true">
                                        Products
                                    </a>
                                    <PdtCatList />
                                </li>

                                {/* <li className="nav-item">
                                    <Link className="nav-link" to={`${rootUrl}/app2/aboutUs`}>About Us</Link>
                                </li> */}

                                <li className="nav-item dropdown mx-5">
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="true">
                                        About us
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" aria-current="page" to={`${rootUrl}/app2/aboutUs/profile`}>Willowest Profile</Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" aria-current="page" to={`${rootUrl}/app2/aboutUs/howWeWork`}>How we work</Link>
                                        </li>
                                        <li><a className="dropdown-item" href="#">Our clients</a></li>
                                        <li><a className="dropdown-item" href="#">Press room</a></li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li><a className="dropdown-item" href="#">Something else here</a></li>
                                    </ul>
                                </li>


                            </ul>
                            </div>
                        </div>
                    </nav>
                    
                </div>

                <div className="row d-flex align-items-baseline">
                        <div className="col text-start" >
                            {/* search */}
                            <form className="d-flex" style={{"maxWidth":"15em"}}>
                                <div className="input-group">
                                    <input className="form-control mx-0" type="search" placeholder="Search" aria-label="Search" />
                                    <button className="btn btn-outline-success" type="submit"><img className="align-middle" src={SvgSearch} style={{"width":"1.2em"}} /></button>
                                </div>
                            </form>

                        </div>
                        <div className="col text-end text-right">
                            <nav className="navbar navbar-expand-lg navbar-light">
                                <ul className="navbar-nav  d-flex col-md-3">
                                        <li className="nav-item dropdown">
                                            <a className="nav-link dropdown-toggle pull-left"
                                                role="button" aria-current="page" href="#"
                                                data-bs-toggle="dropdown" aria-expanded="false"
                                            > <img className="" src={SvgPerson} style={{"width":"1.5em"}} /> Sign in</a>
                                            <ul className="dropdown-menu form-menu">
                                                <li>
                                                    <SignIn className="d-block " />
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item d-flex">
                                            <CartBtn />
                                            {/* <img className="pt-3" src={SvgCart} style={{"width":"1.5em"}} /> */}
                                            {/* <a className="nav-link pull-left"  role="button" aria-current="page" href="#"  data-bs-toggle="dropdown" aria-expanded="false">Cart</a> */}
                                        </li>
                                    </ul>
                            </nav>

                        </div>
                    </div>


            </header>
        }


    </>
}